import { render, staticRenderFns } from "./ClaimEditor.vue?vue&type=template&id=7706ff93&scoped=true"
import script from "./ClaimEditor.vue?vue&type=script&lang=js"
export * from "./ClaimEditor.vue?vue&type=script&lang=js"
import style0 from "./ClaimEditor.vue?vue&type=style&index=0&id=7706ff93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7706ff93",
  null
  
)

export default component.exports